import Api from './Api';

const END_POINT = 'patterns';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    store(pattern) {
        return Api.post(`${END_POINT}`, pattern);
    },
    update(pattern) {
        return Api.patch(`${END_POINT}/${pattern.id}`, pattern);
    },
    change_status(pattern) {
        return Api.patch(`${END_POINT}/${pattern.id}/change-status`, pattern);
    },
}